import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { FormattedMessage } from "react-intl";
import ImportStudentsForm from "../Forms/ImportStudentsForm";

export default function ImportStudentsToClassModal(props) {
  return (
    <Modal isOpen={props.isOpen} toggle={props.toggle}>
      <ModalHeader>
        <FormattedMessage id="ImportFromXlsx" />
      </ModalHeader>
      <ModalBody>
        <ImportStudentsForm
          preSelectedClass={props.preSelectedClass}
          preSelectedClassId={props.preSelectedClassId}
          updateStudents={props.reloadClass}
          dismissModal={props.handleHide}
          studentClasses={props.studentClasses}
        />
      </ModalBody>
    </Modal>
  );
}
